import fish from '../assets/images/arts/fish.jpeg';
import coffe from '../assets/images/arts/coffe.jpeg';
import monster from '../assets/images/arts/monster.jpg';
import boat from '../assets/images/arts/boat.jpg';
import flamingo from '../assets/images/arts/flamingo.jpeg';
import elham from '../assets/images/arts/elham.jpeg';

export const artworks = [
    fish,
    boat,
    monster,
    elham,
    coffe,
    flamingo
]

